import fetchRetry from '../fetchRetry';

const DEFAULT_ERROR_MESSAGE =
  'Something went wrong with your request.' +
  ' ' +
  'If this error persists, submit a ticket via the "Support" tab.';

const createCustomError = (msg = DEFAULT_ERROR_MESSAGE) => new Error(msg);

/**
 * Returns a parsed result from calling fetchRetry.
 * @param {string} url - The URL to call
 * @param {Object} options - Standard fetch options
 */
export const doFetch = (url, options = {}) => {
  const isFormData = options.body instanceof FormData;
  if (!isFormData && typeof options.body !== 'string') {
    options.body = JSON.stringify(options.body);
    options.headers = {
      ...options.headers,
      'Content-type': 'application/json',
    };
  }

  return new Promise((resolve, reject) => {
    fetchRetry(url, options)
      .then(response => {
        if (response.status === 204) {
          return resolve();
        }
        resolve(response.json());
      })
      .catch(response => {
        if (!response || !response.clone) {
          reject(createCustomError());
          return;
        }
        // This block attempts to parse the detail in API error messages if
        // available. Otherwise, throws whatever error was originally raised.
        try {
          response
            .clone()
            .text()
            .then(text => {
              if (!text) {
                throw createCustomError();
              }
              let error = createCustomError(text);
              try {
                const errorJSON = JSON.parse(text);
                if (errorJSON.detail) {
                  error = createCustomError(errorJSON.detail);
                } else {
                  error = createCustomError(errorJSON.statusText || undefined);
                }
              } catch {
                // This catches exceptions that may happen when parsing JSON.
                // In such a case, the error will already be the initialized
                // text value above. Rethrow it.
                throw error;
              }
              // Throw the error so it's rejected in the outer promises' catch.
              throw error;
            })
            .catch(error => {
              // This error can either be a custom error or a logical error
              // that occurred invoking clone() or text() higher up the chain.
              reject(error);
            });
        } catch (error) {
          reject(error);
        }
      });
  });
};

export default doFetch;
